module.exports = __webpack_public_path__ + "static/media/chinese_02.f9590168.jpg";